
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparBoard as ObiBuoySparBoardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-board.js';
 
 
 

 
 export const ObiBuoySparBoard = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-board',
   elementClass: ObiBuoySparBoardElement,
   events: {
     
   }
  });
 
 